export const DISCOVER_MORE_SURFACE = 'discover_more'
export const DISCOVER_MORE_EXPERIMENT = 'discover_more_v1'

export const DISCOVER_MORE_EVENTS = {
  PAGE_OPENED: 'Feature Promo Page Opened',
  PROMO_VIEWED: 'Feature Promo Viewed',
  PROMO_CLICKED: 'Feature Promo Clicked',
  DEMO_REQUESTED: 'Feature Demo Requested',
  DEMO_REQUEST_FAILED: 'Feature Demo Request Failed',
  TOUR_CLICKED: 'Take Tour Clicked',
} as const

export const CHANGELOG_HIGHLIGHT_COUNT = 5

export const CHANGELOG_STALE_TIME_MS = 60 * 60 * 1000

export const PUBLIC_CHANGELOG_URL = 'https://www.procurify.com/changelog/'

export const CHANGELOG_DATE_FORMAT = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as const
